export const StatusPill = ({ value = "unknown", testId }) => {
  const status = String(value).toLowerCase();
  const tone = ["active", "approved", "resolved", "verified", "online", "success"].some((item) => status.includes(item))
    ? "success" : ["pending", "open", "review", "warning"].some((item) => status.includes(item))
      ? "warning" : ["banned", "rejected", "failed", "ended", "danger"].some((item) => status.includes(item)) ? "danger" : "neutral";
  return <span className={`status-pill ${tone}`} data-testid={testId || `status-${status.replace(/[^a-z0-9]+/g, "-")}`}><i />{String(value).replaceAll("_", " ")}</span>;
};